import React from 'react'
import { Link, graphql } from 'gatsby'
import Fade from 'react-reveal/Fade'

import Layout from '../components/layout'
import ArticleCard from '../components/article-card'
import HelmetBuilder from '../components/helmet-builder'

const FeaturedArticleInline = ({ article }) => (
  <Link
    to={`/articles/${article.slug}`}
    className="article-card__featured-wrapper"
    title={`Navigate to: ${article.title}/`}
  >
    <div className="gradient-middle" />
    <div
      className="article-card__featured"
      style={{
        backgroundImage: `url("${article.heroImage.file.url}?fm=jpg&q=80")`,
      }}
    />

    <div className="article-card__content-wrapper">
      <Fade>
        <div className="article-card__category">{article.category.title}</div>
        <div className="article-card__title">{article.title}</div>

        <div className="article-card__teaser">{article.shortDescription}</div>
        <div className="button button__transparent">Read Article</div>
      </Fade>
    </div>
  </Link>
)

// const FeaturedArticleFullBleed = ({ article }) => (
//   <div className="article-card__featured--full-bleed">
//     <Link
//       to={`/articles/${article.slug}/`}
//       className="article-card__background-image"
//       style={{
//         backgroundImage: `url("${article.heroImage.file.url}?fm=jpg&q=80")`,
//       }}
//       title={`Navigate to: ${article.title}`}
//     >
//       <div className="block block__full-bleed">
//         <div className="featured--full-bleed__content-wrapper">
//           <div className="article-card__category" style={{ color: '#fff' }}>
//             {article.category.title}
//           </div>
//           <div className="article-card__title">{article.title}</div>

//           <div className="article-card__teaser">{article.shortDescription}</div>
//         </div>
//       </div>
//     </Link>
//   </div>
// )

const returnProperArticle = (article, index) => {
  if (index === 3) {
    return <FeaturedArticleInline article={article} />
  } else if (index === 7) {
    // return <FeaturedArticleFullBleed article={article} />
    return <FeaturedArticleInline article={article} />
  } else {
    return <ArticleCard article={article} />
  }
}

class Category extends React.Component {
  componentDidMount() {
    // console.log('Category Component Did Mount')
    /* GTM pageview custom event trigger */
    window.dataLayer.push({ virtualTitle: this.props.data.categoryPage.title })
    window.dataLayer.push({ event: 'virtualPageview' })
    const headerClass = 'category_' + this.props.data.categoryPage.slug

    const header = document.getElementsByClassName('header__categories')
    header[0].classList.add(headerClass)
  }

  render() {
    const category = this.props.data.categoryPage
    // const latestArticle = this.props.data.categoryPage.page___article[0]

    const articles = this.props.data.categoryArticles.edges
    const catClass =
      'page__category category_' + this.props.data.categoryPage.slug

    // const backgroundImgStyle = {
    //   backgroundImage: `url("${
    //     latestArticle.heroImage.file.url
    //   }?fm=jpg&q=80&w=1440&h=900")`,
    // }
    const metadata = category.metadata

    return (
      <Layout pathname={this.props.location.pathname}>
        <div className={catClass}>
          <HelmetBuilder
            title={`${metadata.title}`}
            description={metadata.description}
            image={metadata.openGraphImage.file.url}
          />
          <div className="block">
            <div className="category__wrapper">
              <h1 className="category__title">{category.title}</h1>
              <p>{category.shortDescription}</p>
            </div>

            <div className="landing__articles-wrapper">
              {articles.map(({ node }, index) =>
                returnProperArticle(node, index)
              )}
              <div className="landing__article-card placeholder" />
            </div>
          </div>

          {/*<div className="cta">
          <div className="block cta__wrapper">
            <h1>Learn how similar strategies can work for you.</h1>
            <a href="#" className="button button__blue">
              Contact Northern Trust
            </a>
          </div>
        </div>*/}

          {/*
        {category.page___article.map(article => (
          <div>
            <Link to={`/articles/${article.slug}/`}>{article.title}</Link>
          </div>
        ))}
      */}
        </div>
      </Layout>
    )
  }
}
export default Category

export const pageQuery = graphql`
  query CategoryPageQuery($slug: String!) {
    categoryPage: contentfulCategory(slug: { eq: $slug }) {
      title
      slug
      metadata {
        title
        description
        openGraphImage {
          file {
            url
          }
        }
      }
      shortDescription
    }
    categoryArticles: allContentfulPageArticle(
      filter: { category: { slug: { eq: $slug } } }
      sort: { fields: [date], order: DESC }
    ) {
      edges {
        node {
          id
          title
          date
          slug
          shortDescription
          category {
            title
          }
          heroImage {
            file {
              url
            }
          }
          heroImageThumbnail {
            file {
              url
            }
          }
        }
      }
    }
  }
`
